import * as constants from 'redux/constants/shipping.constants';
import * as userConstants from 'redux/constants/user.constants';

const defaultState = {
  loading: false,
  singleQuote: null,
  cartQuote: null,
  zipCode: '',
  trackingGuide: null,
  guide: null,
};

const shippingReducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.SHIPPING_GET_SINGLE_QUOTE_REQUESTED:
      return {
        ...state,
        loading: !!action.value,
        singleQuote: !action.value ? null : state.singleQuote,
        zipCode: '',
      };
    case constants.SHIPPING_GET_CART_QUOTE_REQUESTED:
      return {
        ...state,
        loading: !!action.value,
        cartQuote: !action.value ? null : state.cartQuote,
        zipCode: '',
      };
    case constants.SHIPPING_GET_TRACKING_GUIDE_REQUESTED:
      return {
        ...state,
        loading: !!action.value,
        trackingGuide: !action.value ? null : state.trackingGuide,
        guide: !action.value ? null : state.guide,
      };
    case constants.SHIPPING_GET_SINGLE_QUOTE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        singleQuote: data.quote,
        zipCode: data.zipCode,
      };
    case constants.SHIPPING_GET_CART_QUOTE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        cartQuote: data.quote,
        zipCode: data.zipCode,
      }
    case constants.SHIPPING_GET_TRACKING_GUIDE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        trackingGuide: data.trackingGuide,
        guide: data.guide,
      };
    case constants.SHIPPING_GET_SINGLE_QUOTE_FAILED:
      return {
        ...state,
        loading: false,
        singleQuote: null,
        zipCode: '',
      };
    case constants.SHIPPING_GET_CART_QUOTE_FAILED:
      return {
        ...state,
        loading: false,
        cartQuote: null,
        zipCode: '',
      };
    case constants.SHIPPING_GET_TRACKING_GUIDE_FAILED:
      return {
        ...state,
        loading: false,
        trackingGuide: null,
        guide: null,
      };
    case userConstants.USER_LOGOUT_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default shippingReducer;
